import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActions, Button, IconButton, Chip } from '@mui/material';
import { ArrowBack as ArrowBackIcon, PlayArrow as PlayArrowIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import practicalEvaluationService from '../../../services/practicalEvaluationService';

const PracticalEvaluationTypePicker = () => {
    const navigate = useNavigate();
    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTypes = async () => {
            try {
                const allTypes = await practicalEvaluationService.getTypesFromIndexedDB();
                setTypes(allTypes);
            } catch (e) {
                console.error('Error loading evaluation types:', e);
            } finally {
                setLoading(false);
            }
        };
        loadTypes();
    }, []);

    return (
        <Box sx={{ height: 'calc(100vh - 60px)', backgroundColor: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {/* Header */}
            <Box sx={{ backgroundColor: 'white', borderBottom: '1px solid #e0e0e0', p: 1.5, flexShrink: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={() => navigate('/training-due/practical-evaluation')} edge="start">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight={600}>Select Evaluation Type</Typography>
                </Box>
            </Box>

            {/* Content */}
            <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                    {loading ? (
                        <Typography>Loading...</Typography>
                    ) : types.length === 0 ? (
                        <Typography color="text.secondary">No evaluation types available. Please sync data first.</Typography>
                    ) : (
                        <Grid container spacing={2}>
                            {types.map(type => (
                                <Grid item xs={12} sm={6} md={4} key={type.id}>
                                    <Card elevation={2}>
                                        <CardContent>
                                            <Typography variant="h6" gutterBottom>{type.name}</Typography>
                                            {type.description && (
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                    {type.description}
                                                </Typography>
                                            )}
                                            <Chip
                                                label={`${(type.checklistItems || []).length} checklist items`}
                                                size="small"
                                                sx={{ mt: 1 }}
                                            />
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                startIcon={<PlayArrowIcon />}
                                                onClick={() => navigate(`/training-due/practical-evaluation/${type.slug}/new`)}
                                            >
                                                Start Evaluation
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default PracticalEvaluationTypePicker;
